import { PortFlag } from 'my-account/constants';
import { ModelBase } from 'store/model-base';

export class CarrierInfo extends ModelBase {
    public static idAttribute: string = 'portingFlag';

    public phoneNumber: string;
    public carrierName: string;
    public portingFlag: string;
    public phoneNumberId: string;

    public get isPort(): boolean {
        return this.portingFlag === PortFlag.YES;
    }
}
